import type { AnyRoute } from "@tanstack/react-router";

import { createDriversRoutes } from "./createDriversRoutes";
import { createOperationalUsersRoutes } from "./createOperationalUsersRoutes";
import type { UsersRouteDeps } from "./usersRouteContext";

export type { UsersRouteDeps, UsersRouteFactory } from "./usersRouteContext";

export function createUsersRoutes(deps: UsersRouteDeps): AnyRoute[] {
  return [...createOperationalUsersRoutes(deps), ...createDriversRoutes(deps)];
}
